import { useEffect } from 'react';

// Sitewide share image (1200x630). Pages can pass their own via `image`; everything else
// falls back to this so client-side navigation never leaves a previous page's image behind.
const DEFAULT_IMAGE = 'https://steadyeducation.com/og/default.png';
const DEFAULT_IMAGE_ALT = 'Steady Education — state-approved online real estate CE';

const DEFAULTS = {
  title: 'Steady Education | Arizona Real Estate CE',
  description: 'Arizona Real Estate Continuing Education - Complete your CE hours online with Steady Education.',
};

function setMeta(name, content, attr = 'name') {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function setJsonLd(id, data) {
  if (!data) return;
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

function removeJsonLd(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

export default function useSEO({ title, description, url, image = DEFAULT_IMAGE, imageAlt = DEFAULT_IMAGE_ALT, type = 'website', jsonLd } = {}) {
  useEffect(() => {
    const prevTitle = document.title;

    if (title) document.title = title;

    setMeta('description', description);
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', type, 'property');
    setMeta('og:url', url, 'property');
    setMeta('og:image', image, 'property');
    setMeta('og:image:alt', imageAlt, 'property');
    setMeta('twitter:image', image, 'name');
    setMeta('twitter:title', title, 'name');
    setMeta('twitter:description', description, 'name');

    if (url) setLink('canonical', url);

    if (jsonLd) setJsonLd('page-jsonld', jsonLd);

    return () => {
      document.title = prevTitle;
      removeJsonLd('page-jsonld');
    };
  }, [title, description, url, image, imageAlt, type, jsonLd]);
}
